import React from 'react'
import { Helmet } from 'react-helmet'
import LWCLayout from '../layouts/LWCLayout'
import '../assets/stylesheets/pages/forumambassadors.scss'
import CardList from '../components/forumambassadors/CardList'
import ambassadors from '../../data-static/ambassadors.json'

const ForumAmbassadors = () => {

  let items = [...ambassadors]

  items.forEach(item => {
    item.profileLink = `https://salesforce.com/trailblazer/${item.trailblazerme}/`
    item.profileText = `salesforce.com/trailblazer/${decodeURI(item.trailblazerme)}/`
  })

  const sortedCards = items.sort((a, b) => a.lastName.toLowerCase() !== b.lastName.toLowerCase() ? a.lastName.toLowerCase() < b.lastName.toLowerCase() ? -1 : 1 : 0);

  return (
    <LWCLayout slug={'forumambassadors'}>
        <Helmet>
          <title>Forum Ambassadors</title>

          <meta property="og:title" content="Forum Ambassadors" />
          <meta property="og:image:url" content="https://developer.salesforce.com/resources2/forum-ambassadors/forum-ambassadors-social-image.jpeg" />
          <meta property="og:description" content="Trailblazer Community Forum Ambassadors" />
            
          <meta name="twitter:title" content="Forum Ambassadors" />
          <meta name="twitter:image" content="https://developer.salesforce.com/resources2/forum-ambassadors/forum-ambassadors-social-image.jpeg" />
          <meta name="twitter:description" content="Trailblazer Community Forum Ambassadors" />
        </Helmet>

        <tm-page class="forumambassadors">
          <tm-hero-a
            title="Trailblazer Community Forum Ambassadors"
            subtitle="Forum Ambassadors are superusers and stewards of the online Trailblazer Community. They help maintain a healthy and engaged community by sharing their Salesforce expertise, moderating content, and creating a welcoming space for members."
            background="white"
            cta-href="https://www.salesforce.com/blog/trailblazer-community-forum-ambassador/"
            cta-label="Read the blog"
            img-align="center"
            img-alt="Trailblazer Community Forum Ambassadors icon"
            img-src="https://developer.salesforce.com/resources2/forum-ambassadors/Forum-Ambassador_LP-Hero.png" />
          
          <tm-section-a 
            background="light" 
            title="Trailblazer Community Forum Ambassadors Drive Success with Salesforce" 
            description="Forum Ambassadors empower others to be successful with Salesforce. They answer questions, create valuable content, and share best practices with other Salesforce users. They uphold the integrity of the online community through networking and content moderation.">
          </tm-section-a>
          
          <tm-section-a 
            id="section-2" 
            background="white" 
            title="Forum Ambassador Characteristics"
            description="Forum Ambassadors play a critical role in maintaining an engaged online Trailblazer Community.">
            <tm-card-grid-c img-aspect="60%" img-type="full">
              <tm-grid-item
                title="Leadership"
                description="Forum Ambassadors are community leaders guided by respect and professionalism. They nurture the community through networking, mentorship, and content moderation."
                img-src="https://developer.salesforce.com/resources2/forum-ambassadors/Leadership_370x230.png"
                img-alt="Leadership icon" />

              <tm-grid-item
                title="Knowledge"
                description="Forum Ambassadors are Salesforce product experts who hold Trailhead Ranger Rank. They provide high-quality answers, create easy-to-understand content, and share product feedback in roundatables and listening sessions."
                img-src="https://developer.salesforce.com/resources2/forum-ambassadors/Knowledge_370x230.png"
                img-alt="Knowledge icon" />

              <tm-grid-item
                title="Responsiveness"
                description="Forum Ambassadors are the most engaged members of the online Community, quickly providing the most helpful answers to issues or questions."
                img-src="https://developer.salesforce.com/resources2/forum-ambassadors/Responsiveness_370x230.png"
                img-alt="Responsiveness icon" />
            </tm-card-grid-c>
          </tm-section-a>

          <tm-section-a 
            background="dark" 
            title="Become a Forum Ambassador" 
            description="Trailblazer Community Forum Ambassador applications are currently closed. Check back in September for the new cohort of Forum Ambassadors and learn how you can apply.">
              {/* {
                <>
                <div className="slds-text-align_center">
                  <tds-button-link variant="inverse" href="https://docs.google.com/forms/d/1ryafM0OO0NxAUT1E6fnFKsTL7cIXAIMfjaNU24pcaAQ/edit?pli=1" target="true">APPLY NOW</tds-button-link>
                </div>
                <div className="slds-text-align_center">
                  <a className="link-white" target="_blank" rel="noreferrer" href="https://www.tableau.com/privacy">WE RESPECT YOUR PRIVACY</a> 
                  <span className="pipe-separator">|</span>
                  <a className="link-white" target="_blank" rel="noreferrer" href="mailto:communityfeedback@tableau.com">HAVING TROUBLE?</a>
                </div> 
                </>
              }*/}
          </tm-section-a>

          <tm-section-a
            background="white"
            title="Forum Ambassadors Directory"
            description="Get to know the 2024 Forum Ambassadors.">
              <CardList items={sortedCards} />
          </tm-section-a>

          <tm-section-a
            background="white"
            title="Learn More">
              <tm-card-grid-c img-aspect="60%" img-type="full">
                <tm-grid-item
                  title="Get Help from the Community"
                  description="Learn how the Trailblazer Community can help you learn, get answers, and collaborate with others."
                  cta-title="Watch Now"
                  cta-href="https://salesforce.vidyard.com/watch/PSF5hMXMon4cdNjEHz3uDq"
                  cta-target="true"
                  img-src="https://developer.salesforce.com/resources2/forum-ambassadors/learn-more/trailblazer-community-hero.png"
                  img-alt="Trailblazer Community" />

                <tm-grid-item
                  title="Trailblazer Community: Quick Look"
                  description="Skill up on the Trailblazer Community with Trailhead."
                  cta-title="Earn the Badge"
                  cta-href="https://trailhead.salesforce.com/en/content/learn/modules/trailblazer-community-quick-look?&utm_source=trailblazer_community&utm_medium=web-banner&utm_campaign=TC2"
                  cta-target="true"
                  img-src="https://developer.salesforce.com/resources2/forum-ambassadors/learn-more/trailblazer-community-final.png"
                  img-alt="Trailblazer Community" />

                <tm-grid-item
                  title="Trailhead"
                  description="Learn in-demand skills from anywhere."
                  cta-title="Explore Trailhead"
                  cta-href="https://trailhead.salesforce.com"
                  cta-target="true"
                  img-src="https://developer.salesforce.com/resources2/forum-ambassadors/learn-more/trailhead-logo.png"
                  img-alt="Trailblazer Community" />
              </tm-card-grid-c>
          </tm-section-a>
        
        </tm-page>
    </LWCLayout>
  )
}

export default ForumAmbassadors
